import { createAction } from 'redux-act';

/**
 * Create the action
 */

const sidebarToggleOpen = createAction('SIDEBAR_TOGGLE_OPEN');
const sidebarToggleClose = createAction('SIDEBAR_TOGGLE_CLOSE');

export function openSidebar() {
    return new sidebarToggleOpen();
}

export function closeSidebar() {
    return new sidebarToggleClose();
}

export {
    sidebarToggleOpen,
    sidebarToggleClose
};



// WEBPACK FOOTER //
// ./resources/assets/actions/sidebar/toggle.js